import { INotification } from "infrastructure/notification";

export interface IMessage {
  messageId: string;
  text: string;
  parentMessage: string;
  isParentMessage: boolean;
  version: number;
}

export interface IRelationship {
  messageId: string;
  relationshipMessageId: string;
  isParentMessage: boolean;
  messageVersion: number;
  relationshipMessageVersion: number;
}

export interface IMessageRelationshipsState {
  messageDetails: IMessage;
  isLoading: boolean;
  notifications: INotification[];
  messagesPickerData: IMessage[];
  relationships: IMessage[];
  selectedRelationship: IMessage[];
  newRelationship: IMessage[];
  shouldRedirect: boolean;
}

export const getMessageRelationshipsInitialState = (): IMessageRelationshipsState => {
  return {
    messageDetails: {
      version: 0,
      isParentMessage: false,
      messageId: "",
      parentMessage: "",
      text: ""
    },
    isLoading: false,
    relationships: [],
    notifications: [],
    messagesPickerData: [],
    selectedRelationship: [],
    newRelationship: [],
    shouldRedirect: false
  };
};
